import { getSolanaConfig } from "@anaconda/core/blockchain/configs"
import {
  Blockchain,
  type BlockchainConfig,
  type SolanaBlockchainConfig,
} from "@anaconda/core/blockchain/types"

const REQUIRED_CLIENT_BLOCKCHAINS = [Blockchain.SOLANA] as const

type MarketplaceHostEnvironment = "mainnet" | "testnet" | "dev" | "beta"

function resolveMarketplaceHostEnvironment(
  hostEnvironment?: string,
): MarketplaceHostEnvironment {
  if (
    hostEnvironment === "mainnet" ||
    hostEnvironment === "testnet" ||
    hostEnvironment === "dev" ||
    hostEnvironment === "beta"
  ) {
    return hostEnvironment
  }

  return "mainnet"
}

export type MarketplaceSolanaChain = "solana:mainnet" | "solana:devnet"

export function getMarketplaceSolanaPrivyConfig(hostEnvironment?: string) {
  const resolved = resolveMarketplaceHostEnvironment(hostEnvironment)
  const config = getSolanaConfig(resolved)
  const chain: MarketplaceSolanaChain = config.isTestnet
    ? "solana:devnet"
    : "solana:mainnet"

  return {
    chain,
    rpcUrl: config.rpcUrls[0]?.url ?? "https://api.mainnet-beta.solana.com",
    blockExplorerUrl:
      config.blockExplorers[0]?.url ?? "https://explorer.solana.com",
  }
}

export function getClientSolanaFallbackConfig(
  hostEnvironment?: string,
): SolanaBlockchainConfig {
  const resolved = resolveMarketplaceHostEnvironment(hostEnvironment)
  const staticConfig = getSolanaConfig(resolved)

  return {
    ...staticConfig,
    hostEnvironment: staticConfig.isTestnet ? "testnet" : "mainnet",
    apiKey: "",
  }
}

export function withRequiredClientBlockchains(
  networks: BlockchainConfig[],
  hostEnvironment?: string,
): BlockchainConfig[] {
  const merged = [...networks]

  for (const blockchain of REQUIRED_CLIENT_BLOCKCHAINS) {
    if (merged.some((config) => config.blockchain === blockchain)) {
      continue
    }

    if (blockchain === Blockchain.SOLANA) {
      merged.push(getClientSolanaFallbackConfig(hostEnvironment))
    }
  }

  return merged
}
